import { defineTranslateKeys } from 'lib/tolgee'

export const translations = defineTranslateKeys({
  hideNiche: {
    defaultValue: 'Esconder nicho',
    key: 'niche-card-hideNiche',
  },
  showNiche: {
    defaultValue: 'Mostrar nicho',
    key: 'niche-card-showNiche',
  },
  nicheLimitMessage: (nicheLimit: number) => ({
    key: 'niche-card-nicheLimitMessage',
    parameters: {
      nicheLimit,
    },
    defaultValue: 'Limite de {nicheLimit} temas atingido. Remova um para continuar.',
  }),
})
